###
  Confirm widget
###

class INTENT.widgets.ConfirmAction

  @ATTR_NAME: "data-widget-confirm"

  constructor: (@el) ->
    @s = @.constructor
    @message = @el.attr @s.ATTR_NAME

    @el.on "click", =>
      event.stopPropagation();
      return confirm @message